export default {
  // Hero Section
  capabilitiesHeroTitle: "先进技术",
  capabilitiesHeroSubtitle: "卓越性能",
  capabilitiesHeroDescription: "在Refex Life Sciences，我们的优势在于世界级制造设施、前沿研发和强大监管专业知识的无缝整合。这些能力共同使我们能够以一致性、可扩展性和速度提供高质量的API和复杂仿制药。",
  
  // Tab Navigation
  capabilitiesTabManufacturing: "制造卓越",
  capabilitiesTabResearch: "研发卓越",
  
  // Manufacturing Section
  capabilitiesManufacturingTitle: "制造卓越",
  capabilitiesManufacturingDescription: "我们的全球制造足迹涵盖API、中间体和成品制剂，由严格的监管批准和世界级基础设施支持。这些设施共同使我们能够为80多个国家的合作伙伴提供质量、规模和可靠性。",
  capabilitiesFormulationsTitle: "制剂和复杂仿制药（Extrovis能力）",
  capabilitiesRLFCTitle: "RLFC能力",
  capabilitiesOncologyTitle: "肿瘤和特殊中间体（Modepro能力）",
  capabilitiesExpansionTitle: "扩张",
  capabilitiesExpansionDescription: "2023年为新制造大楼奠基，反映了我们不断增长的规模。",
  capabilitiesLabel: "能力:",
  capabilitiesMore: "更多能力",
  
  // Research Section
  capabilitiesResearchTitle: "研发卓越",
  capabilitiesResearchDescription: "在Refex Life Sciences，创新是我们增长的动力。凭借世界级的研发中心和200多名科学家的团队，我们正在推进API开发和复杂成品制剂（FDF）的前沿。我们的研究专注于创造差异化、可持续和以患者为中心的解决方案，以满足全球医疗保健未满足的需求。",
  capabilitiesApiRDTitle: "研发能力 – RLFC",
  capabilitiesApiRDSubtitle: "先进工艺开发",
  capabilitiesApiRDPoint1Title: "可持续工艺开发",
  capabilitiesApiRDPoint1Description: "具有成本效益、环保的合成策略，实现可扩展性和合规性。",
  capabilitiesApiRDPoint2Title: "手性化学专业知识",
  capabilitiesApiRDPoint2Description: "使用先进的拆分和酶技术开发可扩展的手性工艺。",
  capabilitiesApiRDPoint3Title: "复杂化学能力",
  capabilitiesApiRDPoint3Description: "在格氏反应、N-和O-烷基化、硼氢化物还原和其他专业化学领域拥有成熟的专业知识。",
  capabilitiesApiRDPoint4Title: "杂质和基因毒性控制",
  capabilitiesApiRDPoint4Description: "内部合成、分析和经过验证的风险管理策略，确保全球合规性。",
  capabilitiesApiRDPoint5Title: "技术转移",
  capabilitiesApiRDPoint5Description: "专门的技术服务团队支持无缝工艺放大、HAZOP研究和安全评估。",
  capabilitiesApiRDPoint6Title: "绿色化学原则",
  capabilitiesApiRDPoint6Description: "将可持续性嵌入产品和工艺开发的每个阶段。",
  capabilitiesApiRDPoint7Title: "监管支持",
  capabilitiesApiRDPoint7Description: "全面的分析研发，实现强有力的申报和全球监管响应。",
  capabilitiesFdfRDTitle: "研发能力 – Extrovis",
  capabilitiesFdfRDSubtitle: "复杂制剂开发",
  capabilitiesFdfRDPoint1Title: "超过200名科学家",
  capabilitiesFdfRDPoint1Description: "我们的实体拥有一支由200多名科学家和研究人员组成的团队，致力于开发我们的复杂API和成品剂型药品。",
  capabilitiesFdfRDPoint2Title: "协作 + 专业化",
  capabilitiesFdfRDPoint2Description: "我们的每个团队都专注于不同的专业领域，并得到所有其他部门的全力支持和协作，特别是我们经验丰富的开发质量保证和分析团队。",
  capabilitiesFdfRDPoint3Title: "跨职能方法",
  capabilitiesFdfRDPoint3Description: "我们采用跨职能方法，利用来自多个学科的专业知识，包括分析、工程、质量保证、临床和监管事务。",
  capabilitiesFdfRDPoint4Title: "激情和专业精神",
  capabilitiesFdfRDPoint4Description: "我们的科学和技术团队保持激情和卓越专业精神的心态，同时具备速度、灵活性以及对为全球利益相关者和客户创造价值的渴望。",
  capabilitiesRDPromiseTitle: "我们的研发承诺",
  capabilitiesRDPromiseDescription: "通过对创新、可持续性和监管卓越的不懈关注，Refex Life Sciences正在塑造医疗保健的未来——从突破性API到改善全球患者预后的复杂制剂",
  
  // Modal
  capabilitiesModalKeyCapabilities: "关键能力",
  capabilitiesModalRegulatoryApprovals: "监管批准",
  capabilitiesModalEstablished: "成立",
  capabilitiesModalCapacity: "产能:",
};
